import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { catchError, switchMap } from 'rxjs/operators';
import { ErrorService } from 'src/app/services/error.service';
import { Order } from 'src/app/models/order.model';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'firebase';

@Component({
  selector: 'app-account-dashboard',
  templateUrl: './account-dashboard.component.html',
  styleUrls: ['./account-dashboard.component.css']
})
export class AccountDashboardComponent implements OnInit {
 
  showSpinner:boolean = false;

  orders:Order[]

  constructor(
    private authService:AuthService,
    private router:Router,
    private firestore:AngularFirestore
    ) { }

  ngOnInit() {
    this.getMyPeningOrders();
  }

  async getMyPeningOrders(){
    this.showSpinner = true;
    var uid:string
    const user:User = await this.authService.checkAuth().then(result=>{
      return result
    })
    if(user){
        uid = user.uid;
    }
    const uid$ = new Subject<string>();
    const queryObservable = uid$.pipe(
      switchMap(uid =>
        this.firestore.collection('payment-transactions', ref => ref.where('uid', '==', uid)).get()
      )
    );
    // subscribe to changes
    queryObservable.subscribe(queriedItems => {
      this.showSpinner = false;
      console.log(queriedItems.docs);
      var orders = queriedItems.docs.map(function (doc) {
        var order = doc.data() as Order;
        const id = doc.id;
        order.id = id;
        return order;
      })
      this.orders = orders;
      this.showSpinner = false;
    });

    // trigger the query
    uid$.next(uid);
  }

  routeToCourseDetail(id:string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/course/' + id])
    );
    console.log(url);
    window.open('#/'+url, '_blank');
  }

}
